import { apiGet, apiSend, LoginResponse, toQuery } from '@invite/app-core';
import {
  CalendarBooking,
  OwnedUnits,
  OwnerCalendar,
  OwnerMe,
  SyncStatus,
  type BlockBody,
  type BookStayBody,
  type ChangeStayBody
} from './schemas';

export const listUnits = (): Promise<OwnedUnits> => apiGet('/owner/account/units', OwnedUnits);

/** Same body as `POST /login/teams/:id`: a login object whose token carries the owner role. */
export const switchTeam = (teamId: number): Promise<LoginResponse> =>
  apiSend('POST', '/owner/account/switch-team', { teamId }, LoginResponse);

export const getMe = (): Promise<OwnerMe> => apiGet('/owner/me', OwnerMe);

export const getCalendar = (unitId: number, from: string, to: string): Promise<OwnerCalendar> =>
  apiGet(`/owner/units/${unitId}/calendar${toQuery({ from, to })}`, OwnerCalendar);

export const requestSync = (unitId: number): Promise<SyncStatus> =>
  apiSend('POST', `/owner/units/${unitId}/sync`, undefined, SyncStatus);

/**
 * `keepSessionOn401`: the sheet tells the owner the session is over before signing out, instead
 * of vanishing under a redirect with the typed answers lost without a word.
 */
export const bookStay = (unitId: number, body: BookStayBody): Promise<CalendarBooking> =>
  apiSend('POST', `/owner/units/${unitId}/bookings`, body, CalendarBooking, {
    keepSessionOn401: true
  });

/** 201 for a new block, 200 when a block with these dates is already there. */
export const createBlock = (unitId: number, body: BlockBody): Promise<CalendarBooking> =>
  apiSend('POST', `/owner/units/${unitId}/blocks`, body, CalendarBooking, {
    keepSessionOn401: true
  });

export const deleteBlock = (unitId: number, periodId: number): Promise<unknown> =>
  apiSend('DELETE', `/owner/units/${unitId}/blocks/${periodId}`);

/** 204, also when the stay was already cancelled by an earlier attempt. */
export const cancelStay = (unitId: number, bookingId: number): Promise<unknown> =>
  apiSend('DELETE', `/owner/units/${unitId}/bookings/${bookingId}`);

export const changeStay = (
  unitId: number,
  bookingId: number,
  body: ChangeStayBody
): Promise<CalendarBooking> =>
  apiSend('PATCH', `/owner/units/${unitId}/bookings/${bookingId}`, body, CalendarBooking, {
    keepSessionOn401: true
  });
